import { render, staticRenderFns } from "./TruncatedDescriptionField.vue?vue&type=template&id=73c6e2c0&"
import script from "./TruncatedDescriptionField.vue?vue&type=script&lang=js&"
export * from "./TruncatedDescriptionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports